export const POST_SUBMIT_SURVEY = process.env.REACT_APP_API_URL + "/api/survey/submit";